import React from 'react';
import { Modal } from 'antd-mobile';
import Stores from 'config/Stores';
import config from 'config/Config';

export default function ToMiniProgram({ visible, onClose, path, username, isProd, imgUrl = '' }) {
  const { token } = Stores.AppMod;
  if (!visible) {
    return null;
  }
  const modal_mini_image =
    imgUrl ||
    'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/link_to_common.png';
  const isProds = config.HOST === 'PROD';
  return (
    <Modal
      title=""
      wrapClassName="posterModal"
      transparent
      visible={visible}
      maskClosable
      onClose={() => onClose()}>
      <div className="weappModal">
        <div>
          <wx-open-launch-weapp
            id="launch-btn"
            username={username}
            path={path}
            env-version={isProd ? 'release' : 'trial'}>
            <script type="text/wxtag-template">
              <img src={modal_mini_image} style={{ width: '540px', height: 'auto' }} />
            </script>
          </wx-open-launch-weapp>
        </div>
        <img
          style={{ width: '65px', marginTop: '58px' }}
          src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
          onClick={() => onClose()}
        />
      </div>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/components/CommonMiniModal/index.js